<i18n
  src="@/locales/views/agro_exporter/quality_control/crop_field/show_export_quality_inspect.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="ae_quality_control_crop_field_list_quality_inspects_path"
    :params="{
      agro_exporter_id: agro_exporter_id,
      crop_field_id: crop_field_id,
      producer_id: producer_id,
      exporter_process_quality_template_id: exporter_process_quality_template_id
    }"
  ></go-back-link>
  <bread-crumbs
    :labels="[
      module_name,
      crop_field?.producer?.fullname,
      crop_field?.name,
      quality_template?.name
    ]"
  ></bread-crumbs>
  <template v-if="load_general_data">
    <crop-field-info :crop_field="crop_field" :show_info="true"></crop-field-info>
    <quality-inspect-info
      :quality_inspect="quality_inspect"
      :agro_exporter_id="agro_exporter_id"
      :producer_id="producer_id"
      :crop_field_id="crop_field_id"
      :exporter_process_quality_template_id="
        exporter_process_quality_template_id
      "
    ></quality-inspect-info>
    <tabs-container v-if="option_tabs.length > 0" v-model="tabsProxy" />

    <div
      v-for="(option_tab, index) in option_tabs"
      :key="index"
      class="mt-6"
      v-show="option_tab.current"
    >
      <quality-group-details
        v-if="option_tab.current"
        :use_samplings="quality_template?.use_samplings"
        :quality_attributes="quality_attributes"
        :quality_samplings="quality_samplings"
        :quality_inspect="quality_inspect"
        :quality_group="current_group"
        :quality_template="quality_template"
      />
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import GoBackLink from "@/components/views/layout/GoBackLink.vue";
import CropFieldQualityRequester from "@/views/agro_exporter/requesters/quality_control/crop_field/show_export_quality_inspect.js";
import QualityInspectInfo from "@/components/views/agro_exporter/quality_control/crop_field/QualityInspectInfo.vue";
import QualityGroupDetails from "@/components/views/agro_exporter/quality_control/crop_field/show_inspect/QualityGroupDetails.vue";
import CropFieldInfo from "@/components/views/agro_exporter/quality_control/crop_field/CropFieldInfo.vue";

export default {
  name: "AEProductionCropFieldQualityShowExportQualityInspect",
  components: {
    GoBackLink,
    CropFieldInfo,
    QualityGroupDetails,
    QualityInspectInfo
  },
  data() {
    return {
      load_general_data: false,
      quality_inspect: {},
      quality_template: {},
      crop_field: {},
      option_tabs: [],
      quality_groups: [],
      quality_sampling_details: []
    };
  },
  props: {
    agro_exporter_id: { required: true },
    crop_field_id: {
      required: true
    },
    quality_inspect_id: {
      required: true
    },
    exporter_process_quality_template_id: {
      required: true
    },
    producer_id: {
      required: true
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => {
        this.fetchData();
      })
    );
  },
  computed: {
    current_group: function () {
      return this.quality_groups.find(
        quality_group => quality_group.id == this.find_current_tab?.id
      );
    },
    find_current_tab() {
      return this.option_tabs.find(option_tab => option_tab.current);
    },
    quality_attributes: function () {
      return this.quality_groups
        .find(quality_group => quality_group.id == this.find_current_tab?.id)
        .quality_attributes.sort((a, b) => a.position - b.position);
    },
    quality_samplings: function () {
      let quality_samplings = [];
      for (
        let sampling = 1;
        sampling <= this.quality_inspect.samplings;
        sampling++
      ) {
        let quality_sampling = this.quality_inspect.quality_samplings.find(
          quality_sampling => quality_sampling.sampling == sampling
        );
        quality_samplings.push(quality_sampling || {});
      }
      return quality_samplings;
    },
    tabsProxy: {
      // se hizo una modificación en TabContainer, que vuelve el modelo a objeto, esto lo resuelve temporalmente
      get() {
        // Si ya es un array, lo retorna. Si no, lo convierte usando Object.values.
        return Array.isArray(this.option_tabs)
          ? this.option_tabs
          : Object.values(this.option_tabs);
      },
      set(newValue) {
        // Aseguramos que siempre se guarde como array
        this.option_tabs = Array.isArray(newValue)
          ? newValue
          : Object.values(newValue);
      }
    },
    show_legend: function () {
      return (
        this.quality_attributes.map(qa => qa.abbreviation).filter(abbr => abbr)
          .length > 0
      );
    }
  },
  methods: {
    fetchData: async function () {
      await this.fetchCropField();
      await this.getExportQualityInspect().then(() => {
        this.fetchTemplate();
        this.fetchExportQualityGroups();
      });
      this.load_general_data = true;
    },
    fetchProducer: async function () {
      let response = await CropFieldQualityRequester.fetchProducer(
        this.agro_exporter_id
      );
      this.producer = response.data;
    },
    fetchCropField: async function () {
      let response = await CropFieldQualityRequester.fetchCropField(
        this.agro_exporter_id,
        this.crop_field_id
      );
      this.crop_field = response.data;
    },
    getExportQualityInspect: async function () {
      let response = await CropFieldQualityRequester.getExportQualityInspect(
        this.agro_exporter_id,
        this.quality_inspect_id
      );
      this.quality_inspect = response.data;
    },
    fetchTemplate: async function () {
      let response = await CropFieldQualityRequester.fetchTemplate({
        agro_exporter_id: this.agro_exporter_id,
        quality_template_id: this.quality_inspect.quality_template_id,
        crop_field_id: this.crop_field_id
      });
      this.quality_template = response.data;
    },
    listExportQualityGroups: function () {
      this.quality_groups = this.quality_inspect.quality_samplings
        .map(quality_sampling => quality_sampling.quality_sampling_groups)
        .flat()
        .map(quality_sampling_group => quality_sampling_group.quality_group)
        .reduce(
          (quality_groups, quality_group) =>
            quality_groups.find(item => item.id === quality_group.id)
              ? quality_groups
              : [...quality_groups, quality_group],
          []
        );
    },
    listExporterQualityAttributes: async function (export_quality_group_id) {
      let response =
        await CropFieldQualityRequester.fetchExporterQualityAttributes(
          export_quality_group_id
        );
      this.quality_attributes = response.data.sort(
        (a, b) => a.position - b.position
      );
    },
    findExportQualitySamplingDetailValue: function (quality_attribute_id) {
      let quality_sampling_detail = this.quality_sampling_details.find(
        quality_sampling_detail =>
          quality_sampling_detail.quality_attribute_id === quality_attribute_id
      );

      return (
        quality_sampling_detail?.value ||
        quality_sampling_detail.value_float ||
        quality_sampling_detail.value_bool
      );
    },
    fetchExportQualityGroups: async function () {
      let response = await CropFieldQualityRequester.fetchExportQualityGroups(
        this.agro_exporter_id,
        this.quality_inspect.quality_template_id
      );
      this.quality_groups = response.data;
      this.option_tabs = this.quality_groups.map(eq_group => {
        return {
          id: eq_group.id,
          name: eq_group.name,
          icon: "fas fa-eye",
          current: this.quality_groups[0].id === eq_group.id
        };
      });
    },
    cellValue: function (eq_sampling, eq_attribute_id) {
      if (Object.keys(eq_sampling).length === 0) return;

      return eq_sampling.quality_sampling_groups
        .find(
          sampling_group =>
            sampling_group.quality_group_id == this.find_current_tab.id
        )
        ?.quality_sampling_details?.find(
          sampling_detail =>
            sampling_detail.quality_attribute_id === eq_attribute_id
        )?.value;
    }
  }
};
</script>
